const properties_dev = {
    title: 'CC Self-service',
    redirectSignIn: 'http://localhost:3000/',
    redirectSignOut: 'http://localhost:3000/',
    cognitoDomain: 'selfservice.auth.eu-central-1.amazoncognito.com',
    userPoolId: 'eu-central-1_iX1S8VuXd',
    appClientId: '3l03t43a1omqvbngccq01opunc', 
    identityPoolId: 'eu-central-1:0c2d24e6-a397-4514-9300-f54bb987136a',
    endpointName: "cc",
    endpointUrl: "https://cc-api.selfservice.hannover-re.cloud",
    user_group: "eu-central-1_U1MoOHHep_oktadev", 
};
const properties_prod = {
    title: 'CC Self-service',
    redirectSignIn: 'https://cc.selfservice.hannover-re.cloud/',
    redirectSignOut: 'https://cc.selfservice.hannover-re.cloud/',
    cognitoDomain: 'selfservice.auth.eu-central-1.amazoncognito.com',
    userPoolId: 'eu-central-1_iX1S8VuXd',
    appClientId: '3l03t43a1omqvbngccq01opunc', 
    identityPoolId: 'eu-central-1:0c2d24e6-a397-4514-9300-f54bb987136a',
    endpointName: "cc",
    endpointUrl: "https://cc-api.selfservice.hannover-re.cloud",
    user_group: "eu-central-1_U1MoOHHep_oktadev", 
};

let properties = properties_prod;

export { properties };